module.exports = __webpack_public_path__ + "static/screen-1-26ff5b6f2619676e0808ec0f25218d63.png";